import { Model } from 'modules/core/lib/mobx-rest'

export interface ICareersHeader {
  enabled: boolean
  title: string
  description?: string
  header_image?: string | File | false
}

class CareersHeader extends Model<ICareersHeader> {
  static urlRoot() {
    return '/ats/careers_headers'
  }
}

export default CareersHeader
